import TimerReportedField from "./time-reported";

export default class TimeReportedFieldMinutes extends TimerReportedField {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.TIME_REPORTED_MINUTES
        this.formulaCompatible = false;
    }

    getCsvValue(item) {
        let res = item.reportedTime;
        if (res) res = gd.utils.Time.roundMinutes(res);
        return res;
    }
}